import type { AudioAsset } from "@/components/assets/AudioAsset.js";
import type { AssetLoader } from "@/components/assets/AssetLoader.js";
import earnedAchievementMp3 from "@rosette/assets/src/audio/earned_achievement.mp3";
import earnedAchievementWebm from "@rosette/assets/src/audio/earned_achievement.webm";


export class AchievementResources {
    private readonly earnedAchievementSound: AudioAsset;

    constructor(assetLoader: AssetLoader) {
        this.earnedAchievementSound = assetLoader.loadAudio(
            [earnedAchievementWebm, earnedAchievementMp3],
        );
    }

    getEarnedAchievementSound(): AudioAsset {
        return this.earnedAchievementSound;
    }
}
